/* eslint-disable react/prop-types */
import React from 'react';
import {
  FaInfoCircle,
  FaRegFilePdf,
  FaPaperclip,
  FaRegCopy,
  FaTools,
  FaGlobeAsia,
  FaRegClone,
  FaChalkboardTeacher,
  // FaLink,
  FaTimesCircle,
  FaQuestionCircle,
} from 'react-icons/fa';

import Translate from '../../RightNav/Translate';
import Card from '../../RightNav/Card';
import RelatedDocuments from '../../RightNav/RelatedDocuments';
import Assistance from '../../RightNav/Assistance';
import RelatedSections from '../../RightNav/RelatedSections';
// import ExternalLinks from '../../RightNav/ExternalLinks';
// import TestMyKnowledge from '../../RightNav/TestMyKnowledge';
import ComparisonDocList from '../../Comparison/ComparisonDocList';
import '../style.scoped.scss';
import RelatedContent from '../../RightNav/RelatedContent';
import Glossary from '../../RightNav/Glossary';
import { connect } from 'react-redux';
import About from '../../RightNav/About';
import AboutTheDocument from '../../RightNav/AboutTheDocument';
import SubscriptionFrame from '../../RightNav/SubscriptionFrame';
import Revealr from '../../RightNav/Revealr';
import { BiChip } from 'react-icons/bi';

const CardsList = ({
  activeCard,
  currentDoc,
  user,
  handlePageChange: updatePage,
  handleComparisonDocument,
  handleDismiss,
  handleGlossarySelected,
  handleSetFAQ,
  handlePreviousVersion,
  contentType,
  handleSummary,
}) => {
  const handleSelectedComparisonDocument = (id) => {
    handleComparisonDocument(id);
    handleDismiss();
  };

  const handlePageChange = (type) => {
    handleDismiss();
    updatePage(type);
  };

  const switchUI = (card) => {
    switch (card) {
      case 'RevealrAI': {
        return (
          <Card Icon={<BiChip />} cardTitle='Revealr AI'>
            <Revealr
              handleSummary={handleSummary}
              isSummary={contentType === 'Summary'}
            />
          </Card>
        );
      }
      case 'About Us': {
        return (
          <Card Icon={<FaInfoCircle />} cardTitle='About 1WordFlow'>
            <About handlePageChange={handlePageChange} />
          </Card>
        );
      }
      case 'About': {
        return (
          (currentDoc.versionDate || currentDoc.registrationDate) && (
            <Card Icon={<FaInfoCircle />} cardTitle='About the Document'>
              <AboutTheDocument handlePreviousVersion={handlePreviousVersion} />
            </Card>
          )
        );
      }
      case 'Assistance': {
        return (
          <Card Icon={<FaQuestionCircle />} cardTitle='Assistance'>
            <Assistance handleSetFAQ={handleSetFAQ} />
          </Card>
        );
      }
      case 'PDF': {
        return user && user.restriction > 1 ? (
          <Card Icon={<FaRegFilePdf />} cardTitle='Download'>
            <SubscriptionFrame />
          </Card>
        ) : (
          <Card
            Icon={<FaRegFilePdf />}
            cardTitle='Download'
            cardItems={[{ Text: 'PDF Version' }, { Text: 'Word Version' }]}
          />
        );
      }
      case 'Translate': {
        return (
          <Card Icon={<FaGlobeAsia />} cardTitle='Translate'>
            <Translate />
          </Card>
        );
      }
      case 'Related Documents': {
        return (
          <Card Icon={<FaRegCopy />} cardTitle='Related Documents'>
            {user && user.restriction > 1 ? (
              <SubscriptionFrame />
            ) : (
              <RelatedDocuments />
            )}
          </Card>
        );
      }
      case 'Related Sections': {
        return (
          <Card Icon={<FaChalkboardTeacher />} cardTitle='Related Sections'>
            {user && user.restriction > 1 ? (
              <SubscriptionFrame />
            ) : (
              <RelatedSections />
            )}
          </Card>
        );
      }
      case 'Document Comparison': {
        return (
          <Card Icon={<FaRegClone />} cardTitle='Document Comparison'>
            <ComparisonDocList
              handleSelectedDocument={handleSelectedComparisonDocument}
            />
          </Card>
        );
      }
      case 'Related Content': {
        return (
          <Card Icon={<FaPaperclip />} cardTitle='Related Content'>
            {user && user.restriction > 1 ? (
              <SubscriptionFrame />
            ) : (
              <RelatedContent />
            )}
          </Card>
        );
      }
      case 'Glossary': {
        return (
          <Card Icon={<FaTools />} cardTitle='Glossaries'>
            <Glossary handleGlossarySelected={handleGlossarySelected} />
          </Card>
        );
      }
      default:
        return null;
    }
  };

  return (
    <div id='active-card-wrapper'>
      <div id='close-card-wrapper'>
        <div className='icon-wrapper' onClick={handleDismiss}>
          <FaTimesCircle />
        </div>
        {switchUI(activeCard)}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentDoc: state.document.currentDocument,
  user: state.user.user,
});

const connector = connect(mapStateToProps, null);

export default connector(CardsList);
